import { render, staticRenderFns } from "./serviceList.vue?vue&type=template&id=6b5a4ed7&scoped=true&"
import script from "./serviceList.vue?vue&type=script&lang=js&"
export * from "./serviceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5a4ed7",
  null
  
)

export default component.exports